// ...existing code...
<template>
  <div class="start-page">
    <header class="hero" :style="heroStyle">
      <div class="hero-inner">
        <h1>DPSG Stamm Heilig Geist</h1>
        <p class="hero-sub">Gemeinschaft, Abenteuer und Natur — komm einfach vorbei!</p>
      </div>
    </header>

    <BlackDivider title="Herzlich Willkommen beim Pfadfinderstamm Heilig Geist" />

    <section class="intro container">
      <v-card class="intro-card" elevation="2">
        <v-row no-gutters align="center">
          <v-col cols="12" md="3" class="intro-image-col">
            <v-img :src="require('@/assets/Stammesgeburtstag.jpg')" aspect-ratio="1" class="intro-image"
              contain></v-img>
          </v-col>

          <v-col cols="12" md="9" class="intro-text-col">
            <div class="text-block">
              <p class="lead">
                Bei uns Pfadfinder:innen des Stamms Heilig Geist in Duisburg gibt es jede Menge zu erleben!
              </p>

              <p>
                Am 24.05.1977 wurde unser Stamm Heilig Geist gegründet. Gruppenstunden fanden damals an der
                Heilig-Geist-Kirche an der Semmeringstraße in Buchholz statt. Von dort starteten wir in die
                unterschiedlichsten Abenteuer – Segeltouren auf dem IJsselmeer, viele verschiedene Standlager oder
                Radtouren nach Paris. Auch an Aktionen wie dem Domino-Day oder der 72-Stunden-Aktion des BDKJ hat unser
                Stamm immer wieder teilgenommen.
                2008 wurde die Kirche Heilig Geist geschlossen, 2010 die Kirche und das von den Pfadfindern genutzte
                Pfarrheim abgerissen. Unter dem Motto „Wir sind immer noch da!“ hat unser Stamm nicht aufgegeben. 2013
                fanden wir unsere neue feste Heimat an der Lindenstraße, nicht weit von unserem Gründungsort entfernt.
                In unserer Pfadfinderwohnung haben wir zwei Gruppenräume, die wir im Sommer 2020 frisch renoviert haben.
                Von dort aus starten wir in neue Abenteuer. Die Pfadis haben 2014 eine Deutschlandtour mit dem Zug
                gemacht, 2018 ging es ins Bezirkslager nach Irland und 2019 nach Dänemark ins Diözesanlager. Seit 2022
                geht es wieder regelmäßig ins Stammeslager. Als Piratenmannschaft haben wir Monschau entdeckt, in
                Wiesmoor sind wir durch die Zeit gereist und in Luxemburg wurde der Lageralltag von allen mitbestimmt.
                Auch kleine Aktionen wie eine Übernachtung mit dem Trupp, Versprechensfeiern oder Stammesgeburtstage
                prägen unser Stammesleben.
                Momentan haben wir eine Biber-Bande, eine Wölflings-Meute, einen Juffi-Trupp, eine Pfadfinder- und eine
                Rover-Runde. Jede Woche treffen sich die Gruppen zur Gruppenstunde. Dort ist alles dabei, gemütlich am
                Lagerfeuer sitzen und Stockbrot machen, Spiel und Spaß oder eigene Projekte wie Schwedenstühle bauen.
                Wenn du neugierig bist, komm einfach mal vorbei!
              </p>

              <p class="links">
                <a href="https://heilig-geist.myspreadshop.de/" target="_blank">Merch-Shop</a>
                <span class="sep">•</span>
                <a href="https://www.instagram.com/heigei.duisburg" target="_blank">Instagram @heigei.duisburg</a>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </section>

    <BlackDivider title="Unsere Aktionen und Lager" />

    <section class="actions container">
      <ScoutActions v-for="(action, index) in actions" :key="index" :title="action.title" :year="action.year"
        :text="action.text" :image="action.image" />
    </section>
  </div>
</template>

<script>
import BlackDivider from "./black-divider.vue";
import ScoutActions from "./scout-actions.vue";

export default {
  components: {
    BlackDivider,
    ScoutActions,
  },
  data() {
    return {
      heroStyle: {
        backgroundImage: `linear-gradient(rgba(10,10,10,0.38), rgba(10,10,10,0.18)), url(${require('@/assets/HomeBild.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '380px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      actions: [
        {
          title: "Sommerlager in Luxemburg",
          year: 2026,
          text: "Camp HeiGei: Die Götter des Olymp – Das war unser Motto des Sommerlagers 2026. Mit einem Paket vom Götterboten Hermes machten sich die Gruppen auf den Weg ihre ganz eigene Odyssee zu erleben. Unterwegs warteten viele Abenteuer auf sie: ob Bootfahren, auf einer Dachterrasse übernachten, die Wolfsschlucht erkunden oder einen Raben streicheln. Bei all dem behüteten sie die heiligen Flammen. Beim großen Zusammentreffen aller Gruppen auf dem Zeltplatz vereinten sie diese zu einem schützenden Götterfeuer. Denn die Gefahr der Monster, die Hades aus der Unterwelt befreit hatte, lauerte nicht weit. Medusa, die Hydra, der Zyklop, Cerberus, der Minotaurus und die Scylla bedrohten das Lager. Doch durch Götterchallenges, Olympische Spiele und viel Zusammenhalt wurden sie nacheinander vertrieben. Und Hades? Der bekam am Ende ein episches Turnier geboten und wurde in den Olymp aufgenommen. So endete unser glorreiches Abenteuer. Wieder einmal haben wir auf dem Zeltplatz in Luxemburg eine wunderschöne Sommerlagerzeit mit viel Spaß und unvergesslichen Pfadfindermomenten erlebt.",
          image: require('@/assets/SoLa26.png'),
        },
        {
          title: "Stammesgeburtstag",
          year: 2026,
          text: "Unser Stamm ist 49 Jahre alt geworden und das haben wir gemeinsam gefeiert! Alle Gruppen waren dabei, sogar unsere Kleinsten, die Biber. So konnten sich alle Stammesmitglieder endlich besser kennenlernen. Im Biegerpark erwartete uns eine große Sportspieleshow, bei der alle Kinder und Jugendlichen altersgerecht mitmachen konnten. Ob 1., 2. oder 3. Platz: Für ihren tollen Einsatz bekamen alle eine Medaille. Am Abend ließen wir den Tag bei einem gemütlichen Grillfest mit den Eltern ausklingen. Danke an alle, die diese tolle Party vorbereitet haben. Wir freuen uns schon auf den nächsten Geburtstag. Da wird unser Stamm 50 Jahre alt. Das muss gefeiert werden!",
          image: require('@/assets/Stammesgeburtstag26.png'),
        },
        {
          title: "Sommerlager in Großzerlang",
          year: 2025,
          text: "In diesem Jahr begann die Fahrt ins Lager für alle zusammen. Mit dem Reisebus machten wir uns von Duisburg auf nach Großzerlangen in Brandenburg. Ein Zeltplatz direkt an der Seenplatte erwartete uns. Nachdem in den ersten Tagen das Lager aufgebaut und eingerichtet worden war, erhielten wir die Nachricht, dass die Polizei vor Ort dringend unserer Hilfe benötigt. Und so begann die Detektivausbildung. Wir lernten Fingerabdrücke zu nehmen, Geheimschriften zu entziffern und den Tatort zu sichern. Am Ende der ersten Woche konnten alle zu Detektiven ernannt werden und wir bekamen unsere Detektivmarken überreicht, nur die Marken waren unauffindbar. Die erste Vermutung, dass wir diese einfach in Duisburg vergessen hatten, wurde an dem Morgen widerlegt, als das Materialzelt plötzlich zum Tatort eines Raubes wurde. Jemand hatte unsere Marken gestohlen! Wir machten uns auf die Suche nach dem Täter. Dieser wurde durch gründliche Detektivarbeit entlarvt und die Detektivmarken konnten wiedergefunden werden. Neben der Detektivausbildung genossen wir die Zeit am Lagerfeuer, beim Schwimmen oder auf den Hikes, zu denen jede Gruppe einzeln aufbrach und ihr eigenes kleines Abenteuer erlebte. Ein Highlight war wie immer die Versprechensfeier mit anschließendem Bergfest.",
          image: require('@/assets/SoLa25.png'),
        },
        {
          title: "Bezirkspfingstlager",
          year: 2025,
          text: "Über Pfingsten ging es mit unserem Bezirk Duisburg nach Vechta. Angekommen bauten wir die Zelte auf und freuten uns auf ein Wochenende voller neuer Begegnungen und Spaß. Auch der Regen konnte uns davon nicht abhalten. Am nächsten Tag begann das Abenteuer. Die Kinder und Jugendlichen machten sich gemeinsam auf den Weg, den Duisterstein zu finden und zusammenzusetzen, um das Königreich rund um den Zeltplatz von bösen Dämonen zu befreien. Nachdem jeder eine passende Rolle für sich gewählt hatte – egal ob Ritterin, Magier oder Druide – wurden die Einzelteile des Duistersteins in verschiedenen Missionen errungen, sodass am Ende des Wochenendes das Königreich befreit werden konnte. Für unseren Stamm gab es noch eine Versprechensfeier, bei der viele Wölflinge ihr Versprechen ablegen konnten. Nach einem Wochenende mit Lagerfeuer, Abenteuer und neuen Freundschaften ging es am Pfingstdienstag zurück nach Duisburg.",
          image: require('@/assets/Bezirkspfingstlager.png'),
        },
        {
          title: "PRISMA",
          year: 2025,
          text: "Mit großer Freude bereiten wir Leitenden Pfingst- und Sommerlager, allerlei Aktionstage und Gruppenstunden vor. Um so großartiger ist es zwischen all dem Planen, Organisieren, Diskutieren und Leiten schlicht und einfach mal wieder selbst Teilnehmende*r in einem Lager zu sein! Genau diese Möglichkeit hatten wir auf dem Prisma 2025. Unter dem Motto \"Vielfalt streuen\" haben sich viele tausende Leitende in unserem Bundeszentrum in Westernohe getroffen und dort einige Tage verbracht. Es gab die Möglichkeit, Gleichgesinnte kennenzulernen, zu netzwerken, sich auszutauschen, an liebevoll vorbereiteten Workshops teilzunehmen und bis tief in die Nacht gemeinsam zu feiern - ob auf Konzerten, in eigens eingerichteten Kneipen oder in gemütlicher Runde am Lagerfeuer. Auch die zwischenzeitige Evakuierung des Zeltplatzes wegen schwerem Gewitter konnte uns die Laune nicht verderben und so schauen wir voller Freude auf ein langes Wochenende voller Erinnerungen an diesen einzigartigen Verband zurück und freuen uns schon auf ein hoffentlich nächstes Leitendenlager!",
          image: require('@/assets/PRISMA.png'),
        },
        {
          title: "Ruhr Jamb",
          year: 2024,
          text: "Am 14.09.2024 ging es für unseren Stamm nach Gladbeck zum Ruhr Jamb. Bereits zum achten Mal veranstaltete der Diözesanverband Essen diesen Aktionstag, an dem alle Stämme aus der Diözese zusammen kommen und gemeinsam einen bunten Tag verbringen. Dieses Jahr lautete das Motto „Einfach mal machen“. Nach einer gemeinsamen Auftaktveranstaltung startete das Gruppenprogramm. Auf unsere Wölflinge wartete ein großes Geländespiel, die Juffis und Pfadis wurden auf eine Schnitzeljagd geschickt und die Rover verbrachten den Vormittag mit verschiedenen Challenges. Nach einer Mittagsstärkung luden verschiedene Aktionen ein, einfach mal Dinge auszuprobieren. Ein besonderes Highlight der Juffi-Stufe war dabei der Bungee-Run. Den Abschluss bildeten abends der Gottesdienst sowie die anschließende Party mit Band.",
          image: require('@/assets/Ruhrjamp.png'),
        },
        {
          title: "Sommerlager in Luxemburg",
          year: 2024,
          text: "Mit dem Scouts Chalet in Luxemburg als Ziel machten sich auch 2024 wieder drei Hikes auf den Weg ins Sommerlager. Für die Pfadis und Rover ging es zum Start nach Luxemburg Stadt, um von dort durch die Landschaft zum Zeltplatz zu wandern. Die Juffis verbrachten ihre Hike-Nacht in Belgien, zum Zeltplatz ging es dann zu Fuß über die Grenze. Und auch die Wölflinge erlebten ihr eigenes Hike-Abenteuer. Und auch am Zeltplatz warteten weitere Abenteuer – dieses Jahr mitgeplant von den Gruppenkindern. In den Gruppenstunden vor dem Lager konnten sich die Gruppen Aktivitäten fürs Lager wünschen, die wir dann gemeinsam umgesetzt haben. So haben die Wölflinge verschiedene Experimente durchgeführt und sich im Kreativzelt beim Basteln ausgetobt. Bei den Juffis wurde ein Theaterstück fürs Bergfest geschrieben und mit vollem Erfolg aufgeführt, sowie der Bau einer Jurtenburg angegangen. Die Pfadis bauten – zur Freude aller – einen Pool auf und versahen diesen mit einer Tiki-Bar, an der man kühle Saftcocktails bekam. Die Rover haben eine Stufenspieleshow geplant. Auch ein Ausflug nach Luxemburg Stadt, Schwimmen gehen und gemeinsam Sternschnuppen schauen standen auf dem Programm. Ein besonderes Highlight des Lagers war für viele auch die Versprechensfeier im Sonnenuntergang. ",
          image: require('@/assets/SoLa24.png'),
        },
        {
          title: "Sommerlager in Wiesmoor",
          year: 2023,
          text: "Drei verschiedene Hikes machten sich in der letzten beiden Sommerferienwochen 2023 auf in den Norden Deutschlands. Für die Pfadis und Rover ging es zu Beginn nach Norderney, um von dort aus den Weg zum Zeltplatz zu finden. Für drei Nächte ging es durch Wind und Regen Richtung Zeltplatz. Zwei Tage später machten sich auch die Juffis und Wös auf den Weg und verbrachten die erste Nacht im Zelt an besonderen Orten, bevor sich alle am Sonntag auf unserem Zeltplatz in Wiesmoor getroffen haben. Auch dort angekommen war die Reise noch nicht vorbei: Unsere Jurte wurde zur Zeitreisemaschine und es ging durch die Zeit der Wikinger, Dinosaurier und sogar in die Zukunft, bis wir am Ende im Lager in Monschau landeten – sogar Simons Haare waren plötzlich wieder gelb. Zurück im Jahr 2022 konnte der Bannerdiebstahl beobachtet und der Täter verfolgt werden. Mit der Hilfe der Menschen, die in den einzelnen Zeitaltern getroffen wurden, konnte zwar der Dieb nicht gefasst, das Banner aber wieder gefunden werden. Was ein Glück!",
          image: require('@/assets/SoLa23.png'),
        },
        {
          title: "Sommerlager in Monschau",
          year: 2022,
          text: "Mit Zug und Bus ging es im Juli 2022 für die Gruppenkinder und Leitenden ins Sommerlager nach Monschau. Nach einer aufregenden Anreise, Zelte aufbauen und Platz erkunden, besuchte uns Kapitän HolySpirit auf dem Zeltplatz. Der Kapitän und seine Crew waren mit ihrem Schiff im Sturm gekentert und brauchten Hilfe, um wieder in See stechen zu können. Die Piratenausbildung begann. Fernrohre basteln, das Schiff wieder zusammenbauen und die Suche nach dem verlorenen Schatz – all das haben die Kinder gemeistert und wurden so vom Kapitän zum Teil der Piratencrew ernannt. Was mit einer großen Piratenparty gefeiert wurde. Als waschechte Piraten – dreckig, mit Augenklappen und Papagei – ging es für die Wös und Juffis nach einer Woche in Monschau nach Hause. Pfadis und Rover blieben noch und erkundeten auf Wandertouren die Gegend rund um Monschau, zeigten ihr sportliches Können und sammelten beim Wellnessvormittag noch mal all ihre Kräfte, um danach das Lager abzubauen. In der letzten Nacht konnten wir uns am Lagerfeuer und unter dem Sternenhimmel Monschaus noch einmal die schönsten Lagermomente ins Gedächtnis rufen, bevor wir in der Jurte und einigen Kröten uns in unsere Schlafsäcke kuschelten.",
          image: require('@/assets/Monschau_quer.png'),
        },
        {
          title: "Schlittschuhfahren",
          year: 2020,
          text: "Als ganzer Stamm haben wir uns aufs Eis getraut! Vom BDKJ haben wir in der letzten Session Freikarten für die Eishalle der Füchse in Duisburg bekommen. Mit Wölflingen, Juffis und Rovern ging es an einem Samstagmittag aufs Eis. -	Rückwärtsfahren oder mal auf einem Bein war auch kein Problem – zu mindestens für die Kinder. Während die Leitenden wackelig ihre Runden an der Bande drehten, sausten unsere Juffis bei Guter-Laune-Musik mutig und rasant über das Eis. Dazu passten sie noch auf die Leitenden auf, trauten sich diese einmal in die Mitte der Eisfläche – dabei sollte es doch eigentlich andersrum sein.",
          image: require('@/assets/Schlittschuh.jpg'),
        },
        {
          title: 'Sommerlager "Klebenbleiben" in Dänemark',
          year: 2019,
          text: 'Im Sommer 2019 hat unser Diözesanverband Essen alle Stämme, Bezirke und Siedlungen eingeladen gemeinsam nach Kolding ins Houens Odde Scout Centre zu hiken und dort mit über 1500 Kindern, Jugendlichen und jungen Erwachsenen einige ereignisreiche Tage zu verbringen. Was verbindet uns mit den anderen Bezirken und Stämmen aus dem DV? - Eigentlich erstmal nichts, abgesehen von der Pfadfinderei natürlich. Dennoch passiert es irgendwie ständig, dass man aneinander klebenbleibt. Auch noch im Nachhinein kleben viele gemeinsame Erklebnisse in unserer Erinnerung fest. So zum Beispiel der erbitterte Kampf des Lösemittel-Larrys gegen den Klebstoff der uns Pfadfinder:innen zusammen hält. Auf gemeinsamen Entdeckungen, in Abenteuern und waghalsigen Aktionen konnten wir diesen magischen Klebstoff noch genauer kennen lernen. Das erste reinste Abenteuer war schon der Aufbau. Erstmalig für dieses Lager wurde uns klar, wozu das Rüsthaus 50cm lange Heringe anbietet, nämlich genau für die Kombination von Sturm und durchgeweichter Wiese durch ständige Regenschauer. Eine wahrliche Entdeckung war auch das dänische Müll-Sortierungssystem. Hartplastik? Ah ja, Tonne 7. Achso, das hatte Kontakt mit Lebensmitteln? Ne, dann Restmüll. Paddeltouren um "unsere" Halbinsel, abenteuerliche Wanderungen bei Tag und Nacht, Axtwerfen, Bogenschießen, spannende Geländespiele, riesige Großgruppenspiele, die größte Freiluft-Messe im Diözesanverband und ergreifende Versprechensfeiern sind Momente, die kein Lösemittel mehr aus unseren Erinnerungen löschen kann.',
          image: require('@/assets/Dänemark.png'),
        },
        {
          title: "Iron-Juffi",
          year: 2019,
          text: "Karten und Kompass lesen können – das gehört zum Pfadfinder sein dazu. Um ihre Fähigkeiten auf die Probe zu stellen machten sich unsere Juffis im April 2019 auf den Weg nach Hattingen, um am Iron Juffi der Diözese Essen teilzunehmen. Als Team mussten sie nur mit Hilfe von Karte und Kompass und ohne Hilfe der Leitenden gegen andere Stämme antreten. Es ging darum, möglichst viele Stationen zu finden und dort Punkte zu sammeln, um am Ende als Sieger aus dem Tag hervorzugehen. Aufs Treppchen haben wir es zwar nicht geschafft, aber Spaß hatten wir! Vor allem bei der After-Party mit Curry Wurst und blauer Zuckerwatte!",
          image: require('@/assets/IronJuffi.png'),
        },
        {
          title: "Sommerlager in Irland",
          year: 2018,
          text: "In den Sommerferien 2018 ging es mit dem Bezirk Duisburg ins Lager in Irland. Nach 36 Stunden mit Bus und Fähre kamen wir in Larch Hill an. Natürlich begrüßte uns die grüne Insel mit Regen. Am ersten Morgen kam die Sonne raus und wurde zum ständigen Begleiter in den nächsten zwei Wochen. Unter dem Motto „Pott of Gold“ sammelten die Kinder die Farben des Regenbogens und fanden am Ende des Lagers den Schatz. Auch ein Hike durfte nicht fehlen. Wir wanderten 3 Tage mit dem Rucksack auf dem Rücken durch die grünen Landschaften und übernachteten an den unterschiedlichsten Orten. Nach zwei Wochen bauten wir unsere kleine Zeltstadt wieder ab und machten uns auf dem Heimweg – im Gepäck neue Freundschaften und viele erlebte Abenteuer.",
          image: require('@/assets/IrlandLager.png'),
        },
      ],
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 16px;
  box-sizing: border-box;
}

.hero {
  color: #fff;
  text-align: center;
}

.hero-inner {
  padding: 48px 16px;
  backdrop-filter: blur(2px);
}

.hero h1 {
  margin: 0;
  font-size: 2.1rem;
  letter-spacing: 0.4px;
  font-weight: 700;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);
}

.hero-sub {
  margin-top: 8px;
  opacity: 0.95;
  font-size: 1.05rem;
}

/* Intro card */
.intro {
  margin-top: 20px;
  margin-bottom: 24px;
}

.intro-card {
  padding: 12px;
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff, #fbfbfb);
}

.intro-image-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.intro-image {
  border-radius: 10px;
  width: 100%;
  max-width: 180px;
  box-shadow: 0 6px 18px rgba(20, 24, 28, 0.06);
}

.intro-text-col {
  padding: 20px 20px 20px 12px;
}

.text-block .lead {
  margin: 0 0 10px 0;
  font-weight: 600;
  color: #222;
  line-height: 1.5;
}

.text-block p {
  margin: 8px 0;
  color: #333;
  line-height: 1.6;
  max-width: 70ch;
}

/* links */
.links {
  margin-top: 12px;
}

.links a {
  color: #000000;
  text-decoration: none;
  font-weight: 600;
}

.links .sep {
  margin: 0 10px;
  color: #999;
}

/* actions list spacing */
.actions {
  padding-bottom: 48px;
}

/* Responsive tweaks */
@media (max-width: 960px) {
  .hero-inner {
    padding: 36px 12px;
  }

  .hero h1 {
    font-size: 1.6rem;
  }

  .intro-text-col {
    padding: 16px;
  }

  .intro-image {
    max-width: 140px;
  }
}
</style>
